module.exports = __webpack_public_path__ + "bfea77a764ea443739ef355910a8b81e.jpg";